import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "mt-2 flex justify-between space-x-2 tw"
};
const _hoisted_2 = {
  class: "w-1/2"
};
const _hoisted_3 = {
  class: "mt-2 flex space-x-2 gap-2"
};
const _hoisted_4 = {
  class: "w-1/2 ml-0"
};
const _hoisted_5 = {
  class: "w-1/2 ml-0"
};
const _hoisted_6 = {
  class: "tw mt-2"
};
import { reactive, onMounted } from 'vue';
import LlTextarea from '@/components/LlTextarea.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import CodePicker from '@/components/CodePicker.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
export default {
  __name: 'AdminFeesModal',
  emits: ['confirm', 'remove', 'close'],
  setup(__props, {
    emit: __emit
  }) {
    const invoiceState = useInvoiceState();
    const {
      permissions
    } = storeToRefs(useMeStore());
    const invoiceEditorStore = useInvoiceEditorStore();
    const {
      selectedLineItem
    } = invoiceEditorStore;
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      getIsLocked
    } = useInvoiceState();
    const emit = __emit;
    const {
      removeLineItem
    } = invoiceState;
    const adminFeesModalState = reactive({
      form: {
        id: '',
        description: '',
        date: '',
        accountingService: {},
        amount: '',
        computed: {
          settings: {
            services: '',
            serviceLabel: '',
            accountingService: {},
            expenseInterest: ''
          }
        },
        codes: {
          activity: {
            id: null
          },
          task: {
            id: null
          }
        }
      }
    });
    onMounted(() => {
      adminFeesModalState.form = JSON.parse(JSON.stringify(selectedLineItem));
    });
    const handleCodeChange = event => {
      adminFeesModalState.form.codes = event;
    };
    const handleDescriptionChange = () => {};
    const handleDateChange = () => {};
    const confirm = () => {
      invoiceState.updateLineItem(adminFeesModalState.form);
      emit('close');
    };
    const remove = () => {
      removeLineItem(adminFeesModalState.form);
      emit('remove');
    };
    const cancel = () => emit('close');
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("Edit Admin Fee", -1)]))]),
          _: 1
        }), _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(LlTextarea, {
            label: "Description",
            modelValue: adminFeesModalState.form.description,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => adminFeesModalState.form.description = $event),
            variant: "outlined",
            "hide-details": "true",
            onChange: handleDescriptionChange,
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlDatePicker, {
            modelValue: adminFeesModalState.form.date,
            "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => adminFeesModalState.form.date = $event), _cache[2] || (_cache[2] = $event => handleDateChange())],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(LlTextField, {
            type: 'number',
            label: "Fee (%)",
            modelValue: adminFeesModalState.form.computed.settings.services,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => adminFeesModalState.form.computed.settings.services = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_5, [_createVNode(LlTextField, {
            prefix: '$',
            type: 'number',
            label: "Amount",
            modelValue: adminFeesModalState.form.amount,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => adminFeesModalState.form.amount = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_6, [_createVNode(CodePicker, {
            form: adminFeesModalState.form,
            onCodeChange: handleCodeChange,
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["form", "disabled"])])]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, {
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "mr-2",
              onBtnClick: cancel
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getIsLocked) || _unref(onlyViewInvoice) ? 'Close' : 'Cancel'), 1)]),
              _: 1
            }), !(_unref(onlyViewInvoice) || _unref(getIsLocked)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              class: "ml-2",
              onBtnClick: remove
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Remove ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            append: _withCtx(() => [!(_unref(onlyViewInvoice) || _unref(getIsLocked)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              color: "primary",
              variant: "flat",
              onBtnClick: confirm
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Apply ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};